// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2e-6";
export var headerCell = "_2e-2";
export var loadingStateContent = "_2e-8";
export var rowWrapper = "_2e-4";
export var stickyAggregationCell = "_2e-b";
export var stickyAggregationRow = "_2e-7";
export var stickyColumnCell = "_2e-a";
export var stickyColumnHeaderCell = "_2e-9";
export var table = "_2e-1";
export var virtualRowWrapper = "_2e-5";
export var virtualTableContainer = "_2e-0";
export var white = "_2e-3";